import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehicle-statistics',
  templateUrl: './vehicle-statistics.component.html',
  styleUrls: ['./vehicle-statistics.component.css']
})
export class VehicleStatisticsComponent implements OnInit {
  @Input() entityData: any;
  entityUtilization: any = [];
  drivingBehaviour: any = [];
  activeAlerts: any = [];
  donutColors: any = ['#74d793', '#1687ff', '#eb2f06', 'rgba(212, 180, 255, 1)', '#7efff5'];
  constructor(private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.getEntityUtilization();
    this.getDrivingBehaviour();
    this.getActiveAlerts();
  }

  getEntityUtilization() {
    if (this.entityData?.entityUtilization) {
      this.entityUtilization = [];
      const donut = { values: [], labels: [], type: 'pie', hole: .5, title: "", legend: true, barColor: '#f6f6f6', marker: { colors: this.donutColors } };
      donut.values = Object.values(this.entityData?.entityUtilization);
      donut.labels = Object.keys(this.entityData?.entityUtilization);
      this.entityUtilization.push(donut);
    }
    else {
      this.entityUtilization = [];
    }
  }
  getDrivingBehaviour() {
    if (this.entityData?.entityBehaviour) {
      const xValue: any = Object.values(this.entityData?.entityBehaviour);
      const yValue: any = Object.keys(this.entityData?.entityBehaviour);
      const xValue2: any = xValue.map(val => { return 100 - val })
      this.drivingBehaviour = [{
        y: yValue, x: xValue, type: 'bar', marker: {
          color: '#74d793',
          width: 1
        },
        width: .5,
        orientation: 'h',
        barmode: 'stack',
        title: '',
        margin: {
          l: 80,
          r: 10,
          b: 30,
          t: 0,
          pad: 10
        },
        barColor: '#f6f6f6'
      },
      {
        y: yValue,
        x: xValue2,
        type: 'bar',
        marker: {
          color: '#1687ff',
          width: 1
        },
        width: .5,
        orientation: 'h',
        barmode: 'stack',
        title: '',

      }];
    } else {
      this.drivingBehaviour = [];
    }
  }

  getActiveAlerts() {
    if (this.entityData?.activeAlertDetails) {
      this.activeAlerts = [
        {
          x: this.entityData?.activeAlertDetails.map(({ date }) => date = new DatePipe('en-US').transform(date, 'dd/MM/yyyy')),
          y: this.entityData?.activeAlertDetails.map(({ mechanicalAlertCount }) => mechanicalAlertCount),
          type: 'bar',
          marker: {
            color: '#74d793',
            width: 1
          },
          width: .5,
          title: '',
          barmode: 'stack',
          margin: {
            l: 20,
            r: 10,
            b: 30,
            t: 0,
            pad: 5
          },
          range: null,
          barColor: '#f6f6f6'
        },
        {
          x: this.entityData?.activeAlertDetails.map(({ date }) => date = new DatePipe('en-US').transform(date, 'dd/MM/yyyy')),
          y: this.entityData?.activeAlertDetails.map(({ trafficAlertCount }) => trafficAlertCount),
          type: 'bar',
          marker: {
            color: '#1687ff',
            width: 1
          },
          title: '',
          barmode: 'stack',
          width: .5,
          margin: {
            l: 20,
            r: 10,
            b: 30,
            t: 0,
            pad: 10
          },
          range: null
        }
      ];
    }
    else {
      this.activeAlerts = [];
    }
  }

}
